import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import { isoDateToMMM } from '../../../utils';
import { parseISO } from 'date-fns';
import {IsoDatePicker} from "../../IsoDatePicker";

function dateToExcel(inDate) {
    const returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    return returnDateTime.toString().substr(0, 5);
}


export function FieldTableDateColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    console.log('context is', context);
    useEffect(() => {
        context.registerType({
            dataType: 'date',
            width: () => 'minmax(8em,max-content)',
            className: () => 'column-date column-centered',
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any>) => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if (props.options?.renderer) {
                    return props.options.renderer(props);
                }
                return isoDateToMMM(value);
            },
            // eslint-disable-next-line react/display-name
            renderEditor: (props: FieldRendererProps<any>) => {
                //const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                if (props.options?.editor) {
                    return props.options.editor(props);
                }
                console.log('changup RE',props.options);
                const onChange = (props.options?.onChange?(evt)=>{console.log('changup callthru'); props.options.onChange(evt,props); }:props.field.onChange);
                return <IsoDatePicker {...props.field} {...props.options?.date} fill={true} autoFocus={true} onChange={onChange}/>;
            },
            renderExport:(cell,props: FieldRendererProps<any>):any => {
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                const dateValue = parseISO(value);
                cell.t = 'n';
                if(props.options?.exportFormat=='uk') {
                    cell.z = 'dd/mm/yyyy';
                } else {
                    cell.z = 'dd/mm/yyyy';
//                    cell.z = 'yyyy-mm-dd';
                }
                cell.v = isNaN(dateValue.getTime()) ? '' : dateToExcel(dateValue);
                cell.width = 10;
                return cell;
            }
        });
    }, [context]);
    return null;
}
